import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpService } from './custom-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RollNumberConfigService {

  constructor(private http: CustomHttpService) { }

  getAllRollNumberConfigsWithCount(body: any): Observable<any> {
    return this.http.post(environment.getAllRollNumberConfigsWithCount, body);
  }

  createRollNumberConfig(body: any): Observable<any> {
    return this.http.post(environment.createRollNumberConfig, body);
  }

  updateRollNumberConfig(body: any): Observable<any> {
    return this.http.post(environment.updateRollNumberConfig, body);
  }

  deleteRollNumberConfig(body: any): Observable<any> {
    return this.http.post(environment.deleteRollNumberConfig, body);
  }

  getAllDepartments(body: any): Observable<any> {
    return this.http.post(environment.getAllDepartment, body);
  }
}
